export default {
  CONTRACT: 'contract',
  APPLICATION: 'application',
  UPSELL: 'upsell',
  OFFER: 'offer',
  DEPOSIT: 'deposit',
  PROMISE_TO_PAY: 'promise-to-pay',
  CAMPAIGN: 'campaign'
}
